import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { motion, useAnimation } from "framer-motion";
import { useNavigate, useLocation } from "react-router-dom";
import logo from "../images/logo.png";

const Navbar = () => {
  const [isMobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [prevScrollY, setPrevScrollY] = useState(window.scrollY);
  const [isVisible, setIsVisible] = useState(true);
  const controls = useAnimation();

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;

      if (currentScrollY > prevScrollY && currentScrollY > 50) {
        setIsVisible(false);
      } else {
        setIsVisible(true);
      }

      setPrevScrollY(currentScrollY);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [prevScrollY]);

  useEffect(() => {
    controls.start({
      y: isVisible ? "0%" : "-100%",
      transition: { duration: 0.3 },
    });
  }, [isVisible, controls]);

  const navigate = useNavigate();
  const location = useLocation();
  const isActive = (path) => location.pathname === path;

  const handleServiceClick = () => {
    if (location.pathname !== "/") {
      navigate("/");
      setTimeout(() => {
        document
          .getElementById("services")
          ?.scrollIntoView({ behavior: "smooth" });
      }, 500);
    } else {
      document
        .getElementById("services")
        ?.scrollIntoView({ behavior: "smooth" });
    }
  };

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!isMobileMenuOpen);
  };

  return (
    <motion.nav
      initial={{ y: "-100%" }}
      animate={controls}
      className={`fixed xl:px-24 lg:px-20 poppins-text top-0 left-0 w-full ${
        isMobileMenuOpen ? "bg-white" : "backdrop-blur-md bg-transparent"
      } z-50 flex justify-between items-center p-4 transition-all duration-300`}
    >
      <div className={`flex items-center ${isMobileMenuOpen ? "hidden" : ""}`}>
        <Link to="/">
          <img src={logo} alt="Logo" className="h-36 md:h-36" />
        </Link>
      </div>

      <ul className="hidden md:flex space-x-8 text-lg text-gray-600">
        <motion.li
          className={`hover:text-[#a07855] ${
            isActive("/") ? "text-[#a07855] font-bold" : ""
          }`}
          onClick={handleServiceClick}
        >
          <span className="cursor-pointer">Our Service</span>
        </motion.li>
        {/* <motion.li whileHover={{ scale: 1.1 }} className="hover:text-[#a07855]">
          <Link to="/">News</Link>
        </motion.li> */}
          <motion.li
          className={`hover:text-[#a07855] ${
            isActive("/blog") ? "text-[#a07855] font-bold" : ""
          }`}
        >
          <Link to="/blog">Furblog</Link>
        </motion.li>
        <motion.li
          className={`hover:text-[#a07855] ${
            isActive("/newsletter") ? "text-[#a07855] font-bold" : ""
          }`}
        >
          <Link to="/newsletter">Furnews</Link>
        </motion.li>
        <motion.li
          className={`hover:text-[#a07855] ${
            isActive("/about") ? "text-[#a07855] font-bold" : ""
          }`}
        >
          <Link to="/about">About Us</Link>
        </motion.li>
        <motion.li
          className={`hover:text-[#a07855] ${
            isActive("/contact") ? "text-[#a07855] font-bold" : ""
          }`}
        >
          <Link to="/contact">Contact Us</Link>
        </motion.li>
      </ul>

      <div className="md:hidden flex items-center">
        <button onClick={toggleMobileMenu} className="text-gray-600">
          <svg
            className="w-6 h-6"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M4 6h16M4 12h16M4 18h16"
            ></path>
          </svg>
        </button>
      </div>

      {isMobileMenuOpen && (
        <div className="fixed top-0 right-0 w-full md:w-1/2 bg-white p-6 h-auto md:hidden shadow-lg z-50 overflow-y-auto transition-all duration-300">
          <div className="flex justify-between items-center mb-8">
            <button onClick={toggleMobileMenu} className="text-gray-600">
              <svg
                className="w-6 h-6"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M6 18L18 6M6 6l12 12"
                ></path>
              </svg>
            </button>
          </div>

          <ul className="space-y-4 text-lg text-center text-gray-600">
            <motion.li
              whileHover={{ scale: 1.1 }}
              className={`hover:text-[#a07855] ${
                isActive("/") ? "text-[#a07855] font-bold" : ""
              }`}
              onClick={() => {
                toggleMobileMenu();
                handleServiceClick();
              }}
            >
              <span className="cursor-pointer">Our Service</span>
            </motion.li>
            {/* <motion.li
              whileHover={{ scale: 1.1 }}
              className="hover:text-[#a07855]"
              onClick={toggleMobileMenu}
            >
              <Link to="/">News</Link>
            </motion.li> */}
            <motion.li
              whileHover={{ scale: 1.1 }}
              className={`hover:text-[#a07855] ${
                isActive("/about") ? "text-[#a07855] font-bold" : ""
              }`}
              onClick={toggleMobileMenu}
            >
              <Link to="/about">About Us</Link>
            </motion.li>
            <motion.li
              whileHover={{ scale: 1.1 }}
              className={`hover:text-[#a07855] ${
                isActive("/blog") ? "text-[#a07855] font-bold" : ""
              }`}
              onClick={toggleMobileMenu}
            >
              <Link to="/blog">Furblog</Link>
            </motion.li>
            <motion.li
              whileHover={{ scale: 1.1 }}
              className={`hover:text-[#a07855] ${
                isActive("/newsletter") ? "text-[#a07855] font-bold" : ""
              }`}
              onClick={toggleMobileMenu}
            >
              <Link to="/newsletter">Furnews</Link>
            </motion.li>
            <motion.li
              whileHover={{ scale: 1.1 }}
              className={`hover:text-[#a07855] ${
                isActive("/contact") ? "text-[#a07855] font-bold" : ""
              }`}
              onClick={toggleMobileMenu}
            >
              <Link to="/contact">Contact Us</Link>
            </motion.li>
          </ul>

          <div className="space-y-4 mt-8">
            <Link to="/login">
              <motion.button
                whileHover={{
                  backgroundColor: "#FAFAFA",
                  transition: { duration: 0.3 },
                }}
                className="bg-gray-100 text-gray-800 px-4 py-2 rounded-md w-full"
              >
                Login
              </motion.button>
            </Link>
            <Link to="/signup">
              <motion.button
                whileHover={{
                  backgroundColor: "#BDA697",
                  transition: { duration: 0.3 },
                }}
                className="bg-[#967d6c] text-white px-4 mt-4 py-2 rounded-md w-full"
              >
                Get Started
              </motion.button>
            </Link>
          </div>
        </div>
      )}

      <div className="space-x-4 hidden md:flex ml-4">
        <Link to="/login">
          <motion.button
            whileHover={{
              backgroundColor: "#FAFAFA",
              transition: { duration: 0.3 },
            }}
            className="bg-gray-100 text-gray-800 px-4 py-2 rounded-md"
          >
            Login
          </motion.button>
        </Link>
        <Link to="/signup">
          <motion.button
            whileHover={{
              backgroundColor: "#BDA697",
              transition: { duration: 0.3 },
            }}
            className="bg-[#967d6c] text-white px-4 py-2 rounded-md"
          >
            Get Started
          </motion.button>
        </Link>
      </div>
    </motion.nav>
  );
};

export default Navbar;
